import LyKeyword from './src/index.vue'

LyKeyword.install = function (Vue) {
    Vue.component(LyKeyword.name, LyKeyword)
}

export default LyKeyword



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/keyword/index.js
// module id = null
// module chunks = 